export const roadmappingQueryKeys = {
  roadmap: {
    list: () => ['roadmap', 'list'] as const,
    details: (roadmapId: number) => ['roadmap', roadmapId] as const,
  },
  dataset: {
    detail: (roadmapId: number) => ['roadmap', roadmapId, 'dataset'] as const,
  },
  items: {
    partial: () => ['roadmap', 'items'] as const,
    list: ({ filterKey }: { filterKey?: string } = {}) =>
      ['roadmap', 'items', { filterKey }] as const,
  },
  roadmapViewItems: {
    /** Partial key to invalidate all view items for a roadmap */
    partial: (roadmapId: number) => ['roadmap', roadmapId, 'view'] as const,
    detail: (roadmapId: number, viewId: number) =>
      ['roadmap', roadmapId, 'view', viewId, 'items'] as const,
  },
  visualization: {
    all: (viewId: number) => ['visualization', 'list', viewId] as const,
    detail: (viewId: number, visualizationId: number) =>
      ['visualization', 'detail', viewId, visualizationId] as const,
    byType: (viewId: number, type: string) => ['visualization', 'byType', viewId, type] as const,
  },
  swimlaneLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['swimlane-layout', viewId, visualizationId] as const,
    headerConfig: (viewId: number, visualizationId: number, headerFieldId: string) =>
      ['swimlane-layout', 'header-config', viewId, visualizationId, headerFieldId] as const,
  },
  tableLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['table-layout', viewId, visualizationId] as const,
  },
  timelineLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['timeline-layout', viewId, visualizationId] as const,
  },
  publishedVisualization: {
    detail: (viewId: number, visualizationId: number) =>
      ['published-visualization', viewId, visualizationId] as const,
  },
};
